import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { MasterFileLocation } from "../../../Data/Art57Data/MasterFileLocation";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMasterFileLocation extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new MasterFileLocation(new FieldDefinition(injector)),
        '{param1}{param2}{param3}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Master File Location';
      this.data.model.operationtype = 1;
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      const param1 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype',this.data.model.operationtype);
      let param2 = '';
      let param3 = '';

      if (this.data && this.data.model && this.data.model.mflcountrycode && this.data.model.mflcountrycode.value) {
        param2 = ' - ' +  this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'country',
          this.data.model.mflcountrycode.value
        ); 
      }

      if (this.data && this.data.model && this.data.model.mflcity) {
        param3 = ' - ' + this.data.model.mflcity; 
      }
         
      this.label = this.labelTemplate
                                      .replace('{param1}',param1)
                                      .replace('{param2}',param2)
                                      .replace('{param3}',param3);

    }
  
  override getListItem(): any[] {
    return [
      this.data.model && this.data.model.ev_Code
        ? this.data.model.ev_Code
        : '-',
      this.data.model && this.data.model.operationtype
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        )
        : '-',
      this.data.model && this.data.model.mflcity
        ? this.data.model.mflcity
        : 'City',
      this.data.model &&
        this.data.model.mflcountrycode &&
        this.data.model.mflcountrycode.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'country',
          this.data.model.mflcountrycode.value
        )
        : 'Country',
      '',
    ];
  } 
    
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeMasterFileLocation = new TreeNodeMasterFileLocation(
        this.ioc!,
        newParent
      );
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }